import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { SmartLinkSize } from '../../../../../../constants';
import { getIconSizeStyles } from '../../../utils';
var getIconWidth = function getIconWidth(size) {
  switch (size) {
    case SmartLinkSize.XLarge:
    case SmartLinkSize.Large:
      return '1.5rem';
    case SmartLinkSize.Medium:
    case SmartLinkSize.Small:
    default:
      return '1rem';
  }
};
var getIconStyles = function getIconStyles(size, isDisabled) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n"])), isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)", getIconSizeStyles(getIconWidth(size)));
};
var ActionIcon = function ActionIcon(_ref) {
  var size = _ref.size,
    testId = _ref.testId,
    icon = _ref.icon,
    isDisabled = _ref.isDisabled;
  return jsx("span", {
    css: getIconStyles(size, isDisabled),
    "data-testid": "".concat(testId, "-icon")
  }, icon);
};
export default ActionIcon;